<form (ngSubmit)="lagre()" [formGroup]="skjema" class="e2e-rediger-invitasjon-skjema">
  <inline-skjema>
    <inline-skjema-tittel>{{'Rediger invitasjon' | translate}}</inline-skjema-tittel>

    <medlem-invitasjon-skjema [skjema]="skjema.controls.invitasjon" fokuserEpostFelt="true"/>

    <inline-skjema-handlinger navigasjonforhindret-flash>
      <div class="handlinger-samling">
      <button mat-raised-button type="submit" color="primary" cdkFocusInitial [visSpinner]="lagrer()"
              [disabled]="lagrer() || skjema.invalid" spinnerTekst="{{'Registrerer...'|translate}}">
        {{ "Lagre"|translate }}
      </button>
      <button mat-stroked-button type="button" (click)="avbryt()">
        {{ "Avbryt"|translate }}
      </button>

      <mat-slide-toggle [formControl]="skjema.controls.sendInvitasjon"
                        matTooltip="{{'Skru av denne dersom du ikke ønsker at systemet sender en e-post med invitasjon'|translate}}">
        {{'Send invitasjons-e-post'|translate}}
      </mat-slide-toggle>
      </div>

    </inline-skjema-handlinger>
  </inline-skjema>
</form>
